import { inject, Injectable } from '@angular/core';
import { SELECTED_APPLICATION_ID } from '@dash/randy/tokens/selected-application-id.token';

const COLLECTION_ITEM_READONLY_LOCKS = 'collectionItemReadonlyLocks';

@Injectable({
  providedIn: 'root',
})
export class CollectionItemReadonlyLockService {
  private readonly selectedApplicationId = inject(SELECTED_APPLICATION_ID);

  isLocked(collectionItemId: string): boolean {
    return this.getLockedIds().has(collectionItemId);
  }

  lock(collectionItemId: string): void {
    const lockedIds = this.getLockedIds();
    lockedIds.add(collectionItemId);
    this.saveLockedIds(lockedIds);
  }

  unlock(collectionItemId: string): void {
    const lockedIds = this.getLockedIds();
    lockedIds.delete(collectionItemId);
    this.saveLockedIds(lockedIds);
  }

  private getStorageKey(): string {
    const appId = this.selectedApplicationId();
    return appId ? `${appId}:${COLLECTION_ITEM_READONLY_LOCKS}` : COLLECTION_ITEM_READONLY_LOCKS;
  }

  private getLockedIds(): Set<string> {
    const data = localStorage.getItem(this.getStorageKey());
    if (!data) {
      return new Set<string>();
    }

    try {
      const parsed = JSON.parse(data);
      if (!Array.isArray(parsed)) {
        return new Set<string>();
      }
      return new Set(parsed.filter((id): id is string => typeof id === 'string'));
    } catch (e) {
      console.error('Error loading readonly item locks', e);
      return new Set<string>();
    }
  }

  private saveLockedIds(lockedIds: Set<string>): void {
    const storageKey = this.getStorageKey();
    if (lockedIds.size === 0) {
      localStorage.removeItem(storageKey);
      return;
    }
    localStorage.setItem(storageKey, JSON.stringify([...lockedIds]));
  }
}
